import { Injectable } from '@angular/core';

@Injectable()
export class NavbarService {
    visible = true;

    constructor() { this.visible = true; }

    hide() { this.visible = false; }

    show() { this.visible = true; }

    toggle() { this.visible = !this.visible; }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/navbar/navbar.service.ts